import React, { Component } from 'react';
import { Lock } from 'lucide-react';
import { motion } from 'framer-motion';
export function PricingSection() {
  const rows = [{
    name: 'Ebook Código Calma',
    value: '$35.000'
  }, {
    name: 'Bonus 1: Suplementos Farmacias CL',
    value: '$15.990'
  }, {
    name: 'Bonus 2: Protocolo Desconexión Legal',
    value: '$12.990'
  }, {
    name: 'Bonus 3: Scripts Negociación',
    value: '$14.990'
  }, {
    name: 'Bonus 4: Intervención en Crisis',
    value: '$9.990'
  }, {
    name: 'Bonus 5: Plan Comidas Anti-Estrés',
    value: '$12.990'
  }, {
    name: 'Bonus 6: Checklist Domingo Reset',
    value: '$7.990'
  }, {
    name: 'Bonus 7: Sueño para Turnos',
    value: '$19.990'
  }];
  return <section id="pricing" className="py-24 bg-navy text-white relative overflow-hidden" data-id="element-144">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-10 pointer-events-none" data-id="element-145">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-orange blur-[120px]" data-id="element-146"></div>
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-blue-500 blur-[120px]" data-id="element-147"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-148">
        <div className="text-center mb-12" data-id="element-149">
          <h2 className="font-heading text-3xl md:text-5xl font-bold mb-4" data-id="element-150">
            El Resumen de tu Inversión
          </h2>
          <p className="text-gray-300 text-lg" data-id="element-151">
            Todo lo que necesitas, en un solo lugar.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-navy-800 rounded-2xl border border-white/10 shadow-2xl overflow-hidden" data-id="element-152">
          <div className="p-1 text-center text-sm text-gray-400 md:hidden bg-navy-900 border-b border-white/5" data-id="element-153">
            ← Scroll para ver tabla completa →
          </div>

          <div className="overflow-x-auto" data-id="element-154">
            <table className="w-full text-left border-collapse" data-id="element-155">
              <thead data-id="element-156">
                <tr className="bg-navy-900 border-b border-white/10" data-id="element-157">
                  <th className="py-4 px-6 font-heading font-semibold text-gray-300 uppercase tracking-wider text-sm" data-id="element-158">
                    Componente
                  </th>
                  <th className="py-4 px-6 font-heading font-semibold text-gray-300 uppercase tracking-wider text-sm text-right" data-id="element-159">
                    Valor Real
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-white/5" data-id="element-160">
                {rows.map((row, idx) => <tr key={idx} className="hover:bg-white/5 transition-colors" data-id="element-161">
                    <td className="py-4 px-6 text-gray-200" data-id="element-162">{row.name}</td>
                    <td className="py-4 px-6 text-right text-gray-400" data-id="element-163">
                      {row.value}
                    </td>
                  </tr>)}
                <tr className="bg-navy-900/50" data-id="element-164">
                  <td className="py-6 px-6 font-bold text-xl text-gray-400" data-id="element-165">
                    VALOR TOTAL
                  </td>
                  <td className="py-6 px-6 text-right font-bold text-xl text-gray-500 line-through decoration-red-500/50 decoration-2" data-id="element-166">
                    $115.000 CLP
                  </td>
                </tr>
                <tr className="bg-orange/10 border-t-2 border-orange" data-id="element-167">
                  <td className="py-8 px-6 font-heading font-bold text-2xl md:text-3xl text-white" data-id="element-168">
                    PRECIO HOY
                  </td>
                  <td className="py-8 px-6 text-right font-heading font-extrabold text-3xl md:text-4xl text-orange" data-id="element-169">
                    $6.390 CLP
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="p-8 bg-navy-900 text-center border-t border-white/10" data-id="element-170">
            <p className="text-gray-300 font-medium mb-8 text-lg" data-id="element-171">
              Un solo pago. Acceso de por vida. Sin mensualidades.
            </p>

            <a href="https://www.merlanis.com/cart/53871355822448:1" className="inline-block w-full sm:w-auto bg-orange hover:bg-orange-500 text-white font-bold text-xl py-5 px-10 rounded-xl shadow-[0_0_20px_rgba(230,126,34,0.3)] transition-all transform hover:scale-105 hover:shadow-[0_0_30px_rgba(230,126,34,0.5)] mb-4" data-id="element-172">
              SÍ, QUIERO CÓDIGO CALMA POR $6.390 CLP
            </a>

            <div className="flex items-center justify-center gap-2 text-sm text-gray-400" data-id="element-173">
              <Lock size={16} data-id="element-174" />
              <span data-id="element-175">Pago seguro vía Mercado Pago. Acceso inmediato.</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}